exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__iframe___2ggWN{border:none;width:100%;height:800px}", "", {"version":3,"sources":["/./src/routes/B2BOffersReport/src/routes/B2BOffersReport/containers/index.scss"],"names":[],"mappings":"AACA,uBACE,YAAY,WACD,YACE,CACd","file":"index.scss","sourcesContent":["\n.iframe {\n  border: none;\n  width: 100%;\n  height: 800px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"iframe": "index__iframe___2ggWN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/routes/B2BOffersReport/containers/index.scss
// module id = 1428
// module chunks = 0